export default __webpack_public_path__ + "static/media/regulatory--triple-lanes-go-straight-center-lane--g1.e11d6237.png";